import {API} from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";

//membership plans
export const getMemberhipPlan = (userId, token, membershipplanId) => {
    return fetch(`${API}/membership-plan/${userId}/${membershipplanId}`,{
        method: "GET",
        headers:{
          Accept: "application/json",
          Authorization: `Bearer ${token}`
      },
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
  }

  export const getMemberhipPlans=(userId,token,params)=>{
    const qrString = objectToQueryString(params);
    return fetch(`${API}/membership-plans/${userId}?${qrString}`,{
      method: "GET",
      headers:{
        Accept: "application/json",
        Authorization:`Bearer ${token}`
    },
  })
  .then(response => {
      return response.json();
  })
  .catch(err => { console.error(err); return { error: true, message: err?.message }; })
  }

  export const getMemberhipPlanCount=(userId,token,params)=>{
    const qrString = objectToQueryString(params);
    return fetch(`${API}/membership-plans/count/${userId}?${qrString}`,{
      method: "GET",
      headers:{
        Accept: "application/json",
        Authorization:`Bearer ${token}`
    },
  })
  .then(response => {
      return response.json();
  })
  .catch(err => { console.error(err); return { error: true, message: err?.message }; })
  }


  export const getCustomers=(userId,token,params)=>{
    const qrString = objectToQueryString(params);
    return fetch(`${API}/customers/${userId}?${qrString}`,{
      method: "GET",
      headers:{
        Accept: "application/json",
        Authorization:`Bearer ${token}`
    },
  })
  .then(response => {
      return response.json();
  })
  .catch(err => { console.error(err); return { error: true, message: err?.message }; })
  }